import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { BbitWebShopAlgoliaService } from '@bbitgmbh/webshop.sdk';
import { I18nPipe } from '@bbitgmbh/website.sdk';
import { SortDropdownOverlayRef } from './sort-dropdown.overlay-ref';

@Component({
  selector: 'app-sort-dropdown',
  templateUrl: './sort-dropdown.component.html',
  styleUrl: './sort-dropdown.component.scss',
  imports: [AsyncPipe, I18nPipe],
})
export class SortDropdownComponent {
  algolia = inject(BbitWebShopAlgoliaService);
  private _overlayRef = inject(SortDropdownOverlayRef);

  setIndex(index: string) {
    this.algolia.setCurrentIndex(index);
    this._overlayRef.close();
  }
}
